import JSRouter from "adminPage/JSRouter";
import Ajax from "base/Ajax";
import Message from "base/Message";
import moment from "moment";
import PromiseHelper from "base/PromiseHelper";

JSRouter.register('content', /^\/subscriptions\/?$/, (url_args, page_data) => {

    $("body").on("click", ".js-resubscribe", function () {
        doSubscriptionAction($(this), '/resubscribe');
        return false;
    }).on("click", ".js-confirm", function () {
        doSubscriptionAction($(this), '/confirm');
        return false;
    }).on("click", ".js-unsubscribe", function () {
        doSubscriptionAction($(this), '/', 'DELETE');
        return false;
    });

    function doSubscriptionAction($button, url = "/", method = "POST") {
        if ($button.is(".admin-btn--loading")) return;
        $button.addClass('admin-btn--loading');
        let $row = $button.parents(".admin-table__tr");
        let id = $row.attr("data-id");

        Promise.all([PromiseHelper.timed_promise(600), Ajax.request(method, 'content', 'subscriptions/' + id + url, {})]).then((args) => {
            let data = args[1];
            $button.removeClass("admin-btn--loading");

            $row.find(".js-status").text(data.textStatus);
            $row.find(".js-submitted-date").text(data.dateSubmitted !== null ? moment.unix(data.dateSubmitted.timestamp).format('YYYY-MM-DD HH:mm') : 'N/A');
            $row.find(".js-confirmed-date").text(data.dateConfirmed !== null ? moment.unix(data.dateConfirmed.timestamp).format('YYYY-MM-DD HH:mm') : 'N/A');
            $row.find(".js-unsubscribed-date").text(data.dateUnsubscribed !== null ? moment.unix(data.dateUnsubscribed.timestamp).format('YYYY-MM-DD HH:mm') : 'N/A');

            if (!data.subscribed) {
                $row.find(".js-action").html(eotwJSXFactory('button', {class: "admin-btn admin-btn--table js-resubscribe", type: "button"}, ["Resubscribe"]))
            } else if (!data.confirmed) {
                $row.find(".js-action").html(eotwJSXFactory('button', {class: "admin-btn admin-btn--table js-confirm admin-btn--confirm", type: "button"}, ["Confirm"]))
            } else {
                $row.find(".js-action").html(eotwJSXFactory('button', {class: "admin-btn admin-btn--table js-unsubscribe admin-btn--cancel", type: "button"}, ["Unsubscribe"]))
            }

            new Message("Subscription updated successfully", "", Message.SUCCESS);
        }).catch((e) => {
            console.log(e);
            new Message(e.message, "Couldn't update the subscription");
            $button.removeClass("admin-btn--loading");
        });
    }
});
